import {
    SET_CONVERSION_OVERVIEW,
    TOGGLE_CONVERSION_ACTIVITY_CLEAR,
    TOGGLE_CONVERSION_ACTIVITY_COMPLETE,
    TOGGLE_CONVERSION_ACTIVITY_FINAL,
    TOGGLE_CONVERSION_ACTIVITY_LATER,
    TOGGLE_CONVERSION_ACTIVITY_ONE_WEEK,
    TOGGLE_CONVERSION_ACTIVITY_PAST_DUE,
    TOGGLE_CONVERSION_ACTIVITY_TRIAL,
    SET_MODAL_CONVERSION,
} from '../ActionTypes';

const initialState = {
    conversionOverview: [],
    conversionPartnerOfferings: [],
    filterTrial: false,
    filterFinal: false,
    filterPastDue: false,
    filterOneWeek: false,
    filterLater: false,
    filterComplete: false,
    modalConversion: {},
};

const conversionReduction = (state = initialState, action) => {
    switch (action.type) {
        case SET_MODAL_CONVERSION:
            return {
                ...state,
                modalConversion: action.payload
            };
        case SET_CONVERSION_OVERVIEW:
            return {
                ...state,
                conversionOverview: action.conversions.conversions || [],
                conversionPartnerOfferings:
                    action.conversions.partnerOfferings || [],
            };
        case TOGGLE_CONVERSION_ACTIVITY_CLEAR:
            return {
                ...state,
                filterTrial: false,
                filterFinal: false,
                filterPastDue: false,
                filterOneWeek: false,
                filterLater: false,
                filterComplete: false,
            };
        case TOGGLE_CONVERSION_ACTIVITY_TRIAL:
            return {
                ...state,
                filterTrial: action.status,
            };
        case TOGGLE_CONVERSION_ACTIVITY_FINAL:
            return {
                ...state,
                filterFinal: action.status,
            };
        case TOGGLE_CONVERSION_ACTIVITY_PAST_DUE:
            return {
                ...state,
                filterPastDue: action.status,
            };
        case TOGGLE_CONVERSION_ACTIVITY_ONE_WEEK:
            return {
                ...state,
                filterOneWeek: action.status,
            };
        case TOGGLE_CONVERSION_ACTIVITY_LATER:
            return {
                ...state,
                filterLater: action.status,
            };
        case TOGGLE_CONVERSION_ACTIVITY_COMPLETE:
            return {
                ...state,
                filterComplete: action.status,
            };
        default:
            return state;
    }
};

export default conversionReduction;
